import * as THREE from "three";
import { DEFAULT_CAMERA_SNAPSHOTS } from "../camera-snapshots";
import type { Dimension } from "@src/math/types";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GRID_EXTENT } from "./grid-plane";

const MAX_PAN_RADIUS = GRID_EXTENT * 0.35;
const MIN_PERSPECTIVE_DISTANCE = 2;
const MAX_PERSPECTIVE_DISTANCE = 48;
const MIN_ORTHOGRAPHIC_ZOOM = 0.25;
const MAX_ORTHOGRAPHIC_ZOOM = 4;
export function configureCameras(
  perspectiveCamera: THREE.PerspectiveCamera,
  orthographicCamera: THREE.OrthographicCamera,
): void {
  perspectiveCamera.up.set(0, 0, 1);
  perspectiveCamera.position.fromArray(DEFAULT_CAMERA_SNAPSHOTS[3].position);
  perspectiveCamera.lookAt(0, 0, 0);
  orthographicCamera.position.fromArray(DEFAULT_CAMERA_SNAPSHOTS[2].position);
  orthographicCamera.lookAt(0, 0, 0);
}

export function createPerspectiveControls(
  camera: THREE.PerspectiveCamera,
  canvas: HTMLCanvasElement,
): OrbitControls {
  const controls = new OrbitControls(camera, canvas);
  controls.enableDamping = true;
  controls.dampingFactor = 0.08;
  controls.screenSpacePanning = true;
  controls.minDistance = MIN_PERSPECTIVE_DISTANCE;
  controls.maxDistance = MAX_PERSPECTIVE_DISTANCE;
  controls.maxTargetRadius = MAX_PAN_RADIUS;
  return controls;
}

export function createOrthographicControls(
  camera: THREE.OrthographicCamera,
  canvas: HTMLCanvasElement,
): OrbitControls {
  const controls = new OrbitControls(camera, canvas);
  controls.enableDamping = true;
  controls.dampingFactor = 0.08;
  controls.enableRotate = false;
  controls.screenSpacePanning = true;
  controls.mouseButtons = {
    LEFT: THREE.MOUSE.PAN,
    MIDDLE: THREE.MOUSE.DOLLY,
    RIGHT: THREE.MOUSE.PAN,
  };
  controls.touches = {
    ONE: THREE.TOUCH.PAN,
    TWO: THREE.TOUCH.DOLLY_PAN,
  };
  controls.minZoom = MIN_ORTHOGRAPHIC_ZOOM;
  controls.maxZoom = MAX_ORTHOGRAPHIC_ZOOM;
  controls.maxTargetRadius = MAX_PAN_RADIUS;
  controls.enabled = false;
  return controls;
}

export function resetCameraView(
  dimension: Dimension,
  perspectiveCamera: THREE.PerspectiveCamera,
  perspectiveControls: OrbitControls,
  orthographicCamera: THREE.OrthographicCamera,
  orthographicControls: OrbitControls,
): void {
  if (dimension === 2) {
    orthographicCamera.position.fromArray(DEFAULT_CAMERA_SNAPSHOTS[2].position);
    orthographicCamera.zoom = DEFAULT_CAMERA_SNAPSHOTS[2].zoom;
    orthographicCamera.lookAt(0, 0, 0);
    orthographicCamera.updateProjectionMatrix();
    orthographicControls.target.set(0, 0, 0);
    orthographicControls.update();
    return;
  }

  perspectiveCamera.position.fromArray(DEFAULT_CAMERA_SNAPSHOTS[3].position);
  perspectiveCamera.zoom = DEFAULT_CAMERA_SNAPSHOTS[3].zoom;
  perspectiveCamera.lookAt(0, 0, 0);
  perspectiveCamera.updateProjectionMatrix();
  perspectiveControls.target.set(0, 0, 0);
  perspectiveControls.update();
}
